import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import {
    getSOURCEDictTreeApi
} from 'api'
import { BoundarySlice } from 'redux/reducers'

const initialState = {
    dictData: null, // 数据字典
    locationName: '', // location 名称
    locationId: '', // location id
}

/* 获取数据字典 */
export const getSourceDictDataAction = createAsyncThunk('SourceSlice/getSourceDictDataAction', async (dictType, thunkAPI) => {
    const sourceTypeDataDict = getSOURCEDictTreeApi(dictType[0])
    const sourceStatusDataDict = getSOURCEDictTreeApi(dictType[1])
    const sourceconstructionTypeDict = getSOURCEDictTreeApi(dictType[2])
    return Promise.all([sourceTypeDataDict, sourceStatusDataDict, sourceconstructionTypeDict])
        .then(dictData => dictData)
        .catch(error => thunkAPI.dispatch(BoundarySlice.actions.addError(error)))
})

export const SourceSlice = createSlice({
    name: 'SourceSlice',
    initialState,
    reducers: {
        /* location 名称 */
        addLocationName: (state, action) => {
            state.locationName = action.payload
        },
        /* location id */
        addLocationId: (state, action) => {
            state.locationId = action.payload
        },
    },
    extraReducers: {
        /* 处理数据字典 */
        [getSourceDictDataAction.fulfilled.type]: (state, action) => {
            state.dictData = action.payload
        }
    },
})
